// extracted by mini-css-extract-plugin
export default {"fileEditContainer":"styles_fileEditContainer__EDT3P","fileName":"styles_fileName__52OT7","deleteButton":"styles_deleteButton__venYB"};